// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__bXC69","contentWrapper":"style_contentWrapper__8rz6o","label":"style_label__zsmeY"};